import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import QuantityControlCart from '../helper/QuantityControlCart';
import { addToWishList,addToCompare, removeFromCart, updateCartQuantity } from '../common/slices/productSlice';
import _ from "lodash";
import { Tooltip } from "@mui/material";
  
const CartSectionAmazon = () => {
    const cartItems = useSelector((state) => state.product.cart); // Access cart items from Redux store
   // console.log('cartItems',cartItems)

    const dispatch = useDispatch();
  
   
 
    const handleRemoveItem = (id) => {
      // Dispatch an action to remove the item
       dispatch(removeFromCart(id));

  };

   const handleSubmitWishlist = (product) => {
   
           dispatch(addToWishList(product));  // Dispatch action to add product to cart
           alert("The product has been added to the wishlist! Please note: The data is temporarily saved in the wishlist and will not be finalized until checkout.");
           dispatch(removeFromCart(product?.id));
  
         };
  
      const handleSubmitCompare = (product) => {
  
             dispatch(addToCompare(product));  // Dispatch action to add product to cart
             alert("The product has been added to the compare! Please note: The data is temporarily saved in the compare list and will not be finalized until checkout.");
             dispatch(removeFromCart(product?.id));
  
           };
    const handleUpdateQuantity = (id, quantity) => {
        // Dispatch an action to update quantity
         dispatch(updateCartQuantity({ id, quantity }));

    };

    const calculateSubtotal = (items) =>
        items.reduce((total, item) => total + (item.price-item.discount) * item.quantity, 0);

    const subtotal = calculateSubtotal(cartItems);

    return (
        <section className="cart py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xl-9 col-lg-8">
                        <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                                <table className="table style-three">
                                    <thead>
                                        <tr>
                                            <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Product Name</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Price</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
  {cartItems.length > 0 ? (
    cartItems.map((item) => {
      const product = item;
      const productImage =
        product.images && product.images.length > 0
          ? product.images[0] // Get the first image
          : "assets/images/thumbs/product-placeholder.png"; // Placeholder image

      return (
        <tr key={item.id}>
          <td>
            <button
              type="button"
              onClick={() => handleRemoveItem(item.id)}
              className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
            >
              <i className="ph ph-x-circle text-2xl d-flex" />
              Remove
            </button>
          </td>
          <td>
            <div className="table-product d-flex align-items-center gap-24">
              <Link
                to={`/#`}
                className="table-product__thumb border border-gray-100 rounded-8 flex-center"
              >
                <img
                  src={productImage}
                  alt={product.name || "Product Image"}
                  className="img-fluid"
                />
              </Link>
              <div className="table-product__content text-start">
              <Tooltip title={product.name} arrow>
                <h6 className="title text-lg fw-semibold mb-8">
                  {_.truncate(product.name, { length: 20, omission: "..." })}
                </h6>
              </Tooltip>
            </div>
            </div>
          </td>
          <td>
            <span className="text-lg h6 mb-0 fw-semibold">
              ${(item.price-item.discount).toFixed(2)}
            </span>
          </td>
          <td>
            <QuantityControlCart
              initialQuantity={item.quantity}
              onQuantityChange={(quantity) =>
                handleUpdateQuantity(item.id, quantity)
              }
            />
          </td>
          <td>
            <span className="text-lg h6 mb-0 fw-semibold">
              ${((item.price - item.discount) * item.quantity).toFixed(2)}
            </span>
          </td>
          <tr>
  <td className="px-40 py-32">
    <button
       className="btn btn-main rounded-8 px-64"
      onClick={() => handleSubmitWishlist(item)}
>
      Add To Wishlist <i className="ph-fill ph-heart" />
    </button>
  </td>
</tr>
<tr>
  <td className="px-40 py-32">
    <button
      to="/cart"
      className="btn btn-main rounded-8 px-64"
      onClick={() => handleSubmitCompare(item)}
      >
      Add To Compare <i className="ph-fill ph-shuffle" />
    </button>
  </td>
</tr>
   </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="5" className="text-center">
        Your cart is empty.
      </td>
    </tr>
  )}
</tbody>

                                </table>
                            </div>
                            <div className="flex-between flex-wrap gap-16 mt-16">
                               
                        
                   </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                            <h6 className="text-xl mb-32">Cart Totals</h6>
                            <div className="bg-color-three rounded-8 p-24">
                                <div className="mb-32 flex-between gap-8">
                                    <span className="text-gray-900 font-heading-two">Subtotal</span>
                                    <span className="text-gray-900 fw-semibold">
                                        ${subtotal.toFixed(2)}
                                    </span>
                                </div>
                                <div className="mb-32 flex-between gap-8">
                                    <span className="text-gray-900 font-heading-two">
                                        Estimated Delivery
                                    </span>
                                    <span className="text-gray-900 fw-semibold">Free</span>
                                </div>
                                
                            </div>
                            <div className="bg-color-three rounded-8 p-24 mt-24">
                                <div className="flex-between gap-8">
                                    <span className="text-gray-900 text-xl fw-semibold">Total</span>
                                    <span className="text-gray-900 text-xl fw-semibold">
                                        ${(subtotal).toFixed(2)}
                                    </span>
                                </div>
                            </div>
                            <Link
                                to="/checkout"
                                className="btn btn-main mt-40 py-18 w-100 rounded-8"
                            >
                                Proceed to Checkout
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CartSectionAmazon;
